import { useMemo } from 'react';

import { useCallSipHeader } from 'features/call/call-base/hooks';
import { useProductSipHeader } from 'features/product/hooks';
import { HEADER_METADATA_VALUE_KEY } from 'features/sip/constants';
import { useUserSipHeader } from 'features/user/hooks';
import { useVcoSipHeader } from 'features/vco/hooks';

/**
 * Returns the SInfo header string *value*.
 * @see useMetadataHeader for the key and value.
 */
export const useSipHeaderMetadata = () => {
  const { getCallSipHeader } = useCallSipHeader();
  const { getVcoSipHeader } = useVcoSipHeader();
  const { getUserSipHeader } = useUserSipHeader();
  const { sipHeader: productSipHeader } = useProductSipHeader();

  const getSipHeaderMetadata = useMemo(() => {
    return {
      ...getUserSipHeader(),
      ...getVcoSipHeader(),
      ...getCallSipHeader(),
      ...productSipHeader,
    };
  }, [getCallSipHeader, getUserSipHeader, getVcoSipHeader, productSipHeader]);

  const sipHeaderMetadata = useMemo((): string => {
    return Object.entries(getSipHeaderMetadata).reduce(
      (acc, [tag, value]) => `${acc}${tag}${value}|`,
      HEADER_METADATA_VALUE_KEY
    );
  }, [getSipHeaderMetadata]);

  return { sipHeaderMetadata };
};
